<div *ngIf="balance.balance > 0" [class.acima-da-barra-do-carrinho]="barraDoCarrinhoVisivel" class="balance-cashback-fab pointer" (click)="goToCashback()">
  <div class="balance-cashback">
    <img src="assets/icon/cashback-w.svg" alt="Cashback" height="26px">
    <span class="mp-text">
      <h6>{{ balance.balance | multiCurrency}}</h6>
      <p>Val: {{ balance.expirationDate | date:'dd/MM/yyyy' }}</p>
    </span>
  </div>
</div>
